import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';

export const hideOLDialog = createAction(`${storeName}/hideOLDialog`);
